import { navigate } from "gatsby"
import { Fragment, useCallback, useEffect } from "react"

import {
  amplitudeClient,
  marketingClient,
  useQueryClient,
} from "@trueskin-web/apis"
import { useAuth } from "@trueskin-web/context"
import { Routes, Trans } from "@trueskin-web/translations"

import PhotosUpload from "../../components/photos-upload"

const UploadPhotos = () => {
  const queryClient = useQueryClient()

  const {
    user: {
      subscription: {
        consultations: [{ id: consultationId }],
      },
      firstName,
    },
  } = useAuth()

  const handleUploadSuccess = useCallback(async () => {
    await queryClient.refetchQueries("currentUser")

    amplitudeClient.trackEvent(
      amplitudeClient.ANALYTIC_EVENTS.INITIAL_PICTURES_SUBMITTED
    )

    navigate(Routes.App.Home.url)
  }, [queryClient])

  useEffect(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.UPLOAD_IMAGES_PAGE_OPENED,
    })

    amplitudeClient.trackEvent(
      amplitudeClient.ANALYTIC_EVENTS.INITIAL_PICTURE_UPLOAD_PAGE_VIEWED
    )
  }, [])

  return (
    <div
      data-testid="web-portal-upload-photos"
      data-component-name="StartPhotos"
    >
      <PhotosUpload
        consultationId={consultationId}
        heading={
          <Fragment>
            <Trans i18nKey="Start.Photos.heading" values={{ firstName }} />
            <br />
            <Trans i18nKey="Start.Photos.description" />
          </Fragment>
        }
        onComplete={handleUploadSuccess}
      />
    </div>
  )
}

export default UploadPhotos
